<template>
  <div class="businessAdd">
    <div
      class="contentWrap"
      v-loading="isLoading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(255, 255, 255, 0.8)"
    >
      <div class="page-section">
        <div class="cg-main-title">清算详情</div>
        <div class="header-handle-box">
          <h3 class="state">
            清算订单号： {{lDetail.order_number}} 
            <span class="status">{{lDetail.order_state == 2 ? '已发起清算' : ''}}</span>
            <span class="status">{{lDetail.order_state == 5 ? '退货数量审核中' : ''}}</span>
            <span class="status">{{lDetail.order_state == 4 ? '退货数量审核被拒绝' : ''}}</span>
            <span class="status">{{lDetail.order_state == 3 ? '退货数量审核通过，进入清算付款阶段' : ''}}</span>
            <span class="status">{{lDetail.order_state == 6 ? '清算已完成' : ''}}</span>
          </h3>
        </div>

        <div class="basic-wrap clearfix">
                <div class="img-wrap">
                <el-image
                    class="img"
                    :src="lDetail.productMainImageFile"
                    fit="cover"
                    :preview-src-list="[lDetail.productMainImageFile]"
                ></el-image>
                </div>
                <div class="basic-info">
                <el-row>
                    <div class="line">
                        <span class="lab">商品名称： </span>
                        <span class="val tit">{{lDetail.item_name}}</span>
                    </div>
                    <div class="line">
                        <span class="lab">商品款号： </span>
                        <span class="val tit">{{lDetail.item_style_number}}</span>
                    </div>
                    <div class="line">
                        <span class="lab">供应商： </span>
                        <span class="val tit">{{lDetail.supplierName}}</span>
                    </div>
                    <div class="line">
                        <span class="lab">销售商： </span>
                        <span class="val tit">{{lDetail.dealerName}}</span>
                    </div>
                    <div class="line">
                        <span class="lab">当前定价： </span>
                        <span class="val tit">{{lDetail.item_order_price | tablePrice}} 元</span>
                    </div>
                </el-row>
                </div>
            </div>
        </div>
      </div>
      
      <div class="page-section" v-if="false">
        <div class="cg-mod-title mgt-0">清算详情</div>
        <div class="basic-info mgt-24">
          <el-row>
            <el-col :span="12">
              <div class="line">
                <span class="lab">平台需确认销售商支付金额：</span>
                <span class="lab green">145000.00元</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="line">
                <span class="lab">销售商还需支付总金额：24000.00+130*300 =</span>
                <span class="green">63000.00元</span>
              </div>
            </el-col>
            <el-col :span="24">
              <div class="line">
                <span class="val">2020年3月31日16：00 ：00 供应商同意了销售商的70件退货请求</span>
                <br />
                <span class="val">本次清算，2020年3月31日14：00 ：00 销售商发起了退货70件，退货后自动核销：130件</span>
                <br />
                <span class="val">退货前您还需提交发起支付金额：24000.00元</span>
                <br />
                <span class="val">需平台确认支付金额：145000.00元</span>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>

      <div class="page-section" v-if="lDetail.order_state == 3 || lDetail.order_state == 6">
          <div class="cg-mod-title mgt-0">清算数据</div>
          <div class="basic-info mgt-24">
              <el-row>
                  <!-- <el-col :span="24"><div class="line">
                      <span class="lab">平台需确认销售商支付金额：</span>
                      <span class="lab green"> ? 元</span>
                  </div></el-col> -->
                  <el-col :span="24"><div class="line">
                      <span class="lab">销售商还需支付总金额： </span>
                      <span class="green"> 
                        {{ billList_final.order_arrears_amount }} +
                        <!-- {{ billList_final.order_bill_amount }} = -->
                        {{billList_final.autoEstablish}} x {{lDetail.item_order_price | tablePrice}} x {{lDetail.supplier_rate}}% =
                        {{ billList_final.dealerSumPay }}元 
                      </span>
                  </div></el-col>
                  <el-col :span="24"><div class="line">
                      <span class="val">供应商同意了销售商的{{billList_final.orderRefundQuantity}}件退货请求</span><br>
                      <span class="val">本次清算，
                        {{billList_final.liquidateDataInfo && billList_final.liquidateDataInfo.order_submit_time}} 
                        销售商发起了退货{{billList_final.orderRefundQuantity}}件，
                        退货后自动核销：{{billList_final.autoEstablish}}件</span><br>
                      <span class="val">退货前您还需提交发起支付金额：{{ billList_final.order_arrears_amount }} 元</span><br>
                      <!-- <span class="val">需平台确认支付金额：? 元</span> -->
                  </div></el-col>
              </el-row>
            </div>

            <div class="time-line-title"  v-if="platform_billList_final.liquidateOrderPaymentList">
              <h4 class="time-line-title-h4">
                平台结款支付
                <el-button type="primary" size="small" style="margin-left: 16px" v-if="lDetail.order_state != 6" @click="openUploadSettle()">上传款结凭证</el-button>
              </h4>
              <div class="time-line-title-sub">
                当前平台已确认金额总计{{platform_billList_final.sum_pay_amonut}}元， 还需支付{{platform_billList_final.chargeBalance}}元
              </div>
            </div>
            <ul class="time-line" v-if="platform_billList_final.liquidateOrderPaymentList && platform_billList_final.liquidateOrderPaymentList.length > 0">
              <li class="item" v-for="(pay_ele, index) in platform_billList_final.liquidateOrderPaymentList" :key="index">
                  <div class="item-tail"></div>
                  <div class="item-node"></div>
                  <div class="item-content">
                    <div class="pdb-12">
                        <span class="title"> 
                          <span class="time">{{pay_ele.order_submit_time}}</span>
                          销售商上传了付款凭证，支付了{{pay_ele.order_payment_amount}}元
                        </span>
                          <el-tag type="success" v-if="pay_ele.order_state == 'y'">供应商已确认</el-tag>
                          <el-tag type="info" v-if="pay_ele.order_state == 'p'">待供应商确认</el-tag>
                          <el-tag type="danger" v-if="pay_ele.order_state == 'n'">供应商已拒绝</el-tag>
                      </div>
                      <div class="pdb-12">
                        <template v-for="(img_ele, img_index) in pay_ele.imageFiles">
                            <el-image
                              :key="img_index"
                              v-if="img_ele"
                              class="img"
                              :src="img_ele"
                              fit="cover"
                              :preview-src-list="pay_ele.imageFiles"
                          ></el-image>
                        </template>
                        <span v-if="pay_ele.order_transfer_memo" class="pay-info grey">
                          说明：{{pay_ele.order_transfer_memo}}
                        </span>
                      </div>
                  </div>
              </li>
          </ul>

            <div class="time-line-title"  v-if="billList_final.liquidateOrderPaymentList && billList_final.liquidateOrderPaymentList.length > 0">
              <h4 class="time-line-title-h4">销售商支付</h4>
              <div class="time-line-title-sub">
                当前平台已确认金额总计{{billList_final.order_pay_amount}}元， 还需支付{{billList_final.chargeBalance}}元
              </div>
            </div>
            <ul class="time-line" v-if="billList_final.liquidateOrderPaymentList && billList_final.liquidateOrderPaymentList.length > 0">
              <li class="item" v-for="(pay_ele, index) in billList_final.liquidateOrderPaymentList" :key="index">
                  <div class="item-tail"></div>
                  <div class="item-node"></div>
                  <div class="item-content">
                    <div class="pdb-12">
                        <span class="title"> 
                          <span class="time">{{pay_ele.order_submit_time}}</span>
                          销售商上传了付款凭证，支付了{{pay_ele.order_payment_amount}}元
                        </span>
                          <el-tag type="success" v-if="pay_ele.order_state == 'y'">供应商已确认</el-tag>
                          <el-tag type="info" v-if="pay_ele.order_state == 'p'">待供应商确认</el-tag>
                          <el-tag type="danger" v-if="pay_ele.order_state == 'n'">供应商已拒绝</el-tag>
                          
                          <el-button type="primary" size="small" style="margin-left: 16px" v-if="lDetail.order_state != 6 && pay_ele.order_state == 'p'" @click="getBillPayDetail(billList_final, pay_ele)">确认付款凭证</el-button>
                      </div>
                      <div class="pdb-12">
                        <template v-for="(img_ele, img_index) in pay_ele.imageFiles">
                            <el-image
                              :key="img_index"
                              v-if="img_ele"
                              class="img"
                              :src="img_ele"
                              fit="cover"
                              :preview-src-list="pay_ele.imageFiles"
                          ></el-image>
                        </template>
                        <span v-if="pay_ele.order_transfer_memo" class="pay-info grey">
                          说明：{{pay_ele.order_transfer_memo}}
                        </span>
                      </div>
                  </div>
              </li>
          </ul>
      </div>

      <!-- <div class="page-section" v-if="lDetail.order_state == 3 || lDetail.order_state == 6">
          <div class="cg-mod-title mgt-0">销售商付款明细</div>
          <ul class="time-line">
              <li class="item" v-for="(pay_ele, index) in billList_final.liquidateOrderPaymentList" :key="index">
                  <div class="item-tail"></div>
                  <div class="item-node"></div>
                  <div class="item-content">
                      <div class="item-tit">
                          {{pay_ele.order_submit_time}}
                      </div>
                      <div class="item-box">
                        <div class="pdb-12">
                            <span class="title"> 
                              销售商于{{pay_ele.order_submit_time}}上传了付款凭证，支付了{{pay_ele.order_payment_amount}}元
                            </span>
                              <el-tag type="success" v-if="pay_ele.order_state == 'y'">供应商已确认</el-tag>
                              <el-tag type="info" v-if="pay_ele.order_state == 'p'">待供应商确认</el-tag>
                              <el-tag type="danger" v-if="pay_ele.order_state == 'n'">供应商已拒绝</el-tag>
                              
                              <button class="cg-btn red-border mgl-16" v-if="pay_ele.order_state == 'p'" @click="getBillPayDetail(billList_final, pay_ele)">确认付款凭证</button>
                          </div>
                          <div class="pdb-12">
                            <template v-for="(img_ele, img_index) in pay_ele.imageFiles">
                                <el-image
                                  :key="img_index"
                                  v-if="img_ele"
                                  class="img"
                                  :src="img_ele"
                                  fit="cover"
                                  :preview-src-list="pay_ele.imageFiles"
                              ></el-image>
                            </template>
                            
                            <span v-if="pay_ele.order_transfer_memo" class="pay-info grey">
                              说明：{{pay_ele.order_transfer_memo}}
                            </span>
                          </div>
                      </div>
                  </div>
              </li>
              <li class="item">
                  <div class="item-tail"></div>
                  <div class="item-node"></div>
                  <div class="item-content">
                      <div class="item-tit">
                          {{billList_final.order_submit_time}}
                      </div>
                      <div class="item-box">
                        <div class="grey">
                          销售商应向您支付总计<span class="green">{{billList_final.dealerSumPay}}</span>元
                        </div>
                      </div>
                  </div>
              </li>
          </ul>
      </div> -->

      <div class="page-section">
            <div class="cg-mod-title mgt-0">清算清单</div>
            <div class="take-order-table clearing">
                <table class="table">
                    <tr class="th">
                        <th width="">下单订单号</th>
                        <th width="">下单总数</th>
                        <th width="">核销对应<br>价格</th>
                        <th width="">已核销<br>件数</th>
                        <th width="">未核销<br>件数</th>
                        <th width="">已发起<br>付款金额</th>
                        <th width="">已核销未发起<br>付款金额</th>
                        <th width="">平台已确认<br>收款金额</th>
                        <th width="">平台未确认<br>收款金额</th>
                        <th width="">⽋款</th>
                    </tr>
                    <tr v-for="(item, index) in lDetail.orderPurchaseList" :key="index">
                        <td>{{item.order_number}}</td>
                        <td>{{item.order_purchase_quantity}}</td>
                        <td>￥{{item.item_order_price | tablePrice}}</td>
                        <td>/</td>
                        <td>/</td>
                        <td>/</td>
                        <td>/</td>
                        <td>/</td>
                        <td>/</td>
                        <td>/</td>
                    </tr>
                    
                </table>
            </div>
        </div>
        <!-- 确认付款凭证 -->
        <el-dialog
          title="确认付款凭证"
              :visible.sync="supplierSurePayPop"
              width="500px"
              :close-on-click-modal="false"
          >
              <div class="cg-dialog-body">
                  <div class="line">清算订单号：<span class="black">{{lDetail.order_number}}</span></div>
                  <div class="line pdb-20">商品款号：<span class="black">{{lDetail.item_style_number}}</span></div>

                  <!-- <div class="line pdb-20">本次付款周期期间明细账单：</div>
                  <div class="line">已核销总数：<span class="black">--件</span></div>
                  <div class="line">剩余未核销数：<span class="black">--件</span></div>
                  <div class="line pdb-20">销售需支付金额：<span class="black">{{platformPeriodPayDetail.order_bill_amount}}元</span></div> -->

                  <div class="line">本期账单累计已支付：<span class="black"> {{billPeriodPayDetail.order_pay_amount}}元</span></div>
                  <div class="line pdb-20">本期需支付金额：<span class="red"> {{billPeriodPayDetail.chargeBalance}}元</span></div>

                  <div class="line">本次销售商付款金额：<span class="black">{{billSinglePayDetail.order_payment_amount}}元</span></div>
                  <div class="line">剩余欠款金额：<span class="red">{{ billSinglePayDetail.restPay }}元</span></div>
              </div>
              <div slot="footer" class="dialog-footer">
                <el-button type="danger" @click="platformSurePay('n')">未收到{{billSinglePayDetail.order_payment_amount}}元，驳回要求重新提交</el-button>
                <el-button type="primary" @click="platformSurePay('y')">确认收到{{billSinglePayDetail.order_payment_amount}}元</el-button>
              </div>
        </el-dialog>

        <!-- 平台上传结款凭证 -->
        <el-dialog
          title="上传结款凭证"
          :visible.sync="uploadsettlePayPop"
          width="800px"
          :close-on-click-modal="false"
        >
            <div class="cg-dialog-body">
                <div class="line">清算订单号：<span class="black">{{lDetail.order_number}}</span></div>
                <div class="line pdb-20">商品款号：<span class="black">{{lDetail.item_style_number}}</span></div>

                <div class="line pdb-20">本次付款明细账单：</div>
                <div class="line">本期账单总金额：<span class="black">{{platformPopShowData.sumAmount}}元</span></div>
                <div class="line">本期账单累计已支付：<span class="black">{{platformPopShowData.hadPaidAmount}}元（供应商已确认的支付金额）</span></div>
                <div class="line pdb-20">本期还需支付金额：<span class="red">{{platformPopShowData.restPayAmount}}元</span>（本周期总金额 - 供应商已确认的支付金额）</div>

                <el-form
                  ref="ruleForm" label-width="160px"
                  :model="uploadsettleForm" :rules="uploadsettlerules"
                >
                  <el-form-item label="本次实际付款金额：" prop="amount">
                    <el-input placeholder="请输入付款金额"
                      style="width: 300px"  
                      :value="uploadsettleForm.amount"
                      @input="inputPriceHandle"
                      @blur="blurPriceHandle"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="上传结款凭证：">
                    <div>
                      <el-upload
                        :action="uploadFileApi"
                        name="files"
                        list-type="picture-card"
                        :file-list="uploadsettleImgsList"
                        :multiple="false"
                        :data="uploadData"
                        :on-remove="handleRemove"
                        :before-upload ="beforeUpload"
                        :on-success="onSuccess"
                        :on-error="onError"
                        accept="image/*"
                        >
                        <i class="el-icon-plus"></i>
                      </el-upload>
                    </div>
                  </el-form-item>
                  <el-form-item label="付款说明：">
                    <el-input type="textarea" placeholder="请输入说明，最多300个字" v-model="uploadsettleForm.memo"></el-input>
                  </el-form-item>
                </el-form>

              </div>
            <div>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="uploadsettlePayPop = false">取 消</el-button>
            <el-button type="primary" @click="uploadsettleSubmit">确 定</el-button>
          </div>
        </el-dialog>
  </div>
</template>

<script>
import { json, wordData, utils } from "@/common/common.js";
import { ajaxPost, api } from "@/common/request.js";
import { lockOrderState } from "@/common/order-state.js";
import { accMul, validatePrice } from "@/common/tool.js";
export default {
  data() {
    var validatePriceFn = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入金额'))
      } else if (!validatePrice(value)) {
        callback(new Error('金额格式不正确'))
      } else {
        callback();
      }
    }
    return {
      isLoading: false,

      lDetail: {
        dealerName: '',
        dealer_user_id: '',
        itemFeeSplitting: '',
        supplier_rate: "",
        dealer_rate: "",
        item_id: '',
        item_name: '',
        item_order_price: '',
        item_style_number: '',
        orderPurchaseList: [],
        order_id:  '',
        order_number: '',
        order_state: '',
        productMainImageFile:  '',
        supplierName: '',
        supplier_user_id: '',
      },
    
      // 清算相关数据
      liquidateDataInfo: '',
      liquidateDataInfo_data: '',

      // 确认退货数量弹框
      confirmReturnGoodsPop: false,
      returnGoodsList: [],
      currentReturnGoods: {},

      // 确认销售商付款
      supplierSurePayPop: false,
      billList_final_list: [],
      billList_final: {},
      billPeriodPayDetail: {},
      billSinglePayDetail: {},

      // 平台结款
      platformUploadPayPop: false,
      platform_billList_final_list: [],
      platform_billList_final: {},
      platform_billPeriodPayDetail: {},
      platform_billSinglePayDetail: {},

      // 上传结款凭证 弹框
      uploadsettlePayPop: false,
      uploadFileApi: api.baseUrl + '/file/uploadfilebatch',
      uploadData: {
        imageType: 12301,
        imageUserId: ''
      },
      platformPopShowData: {},
      uploadsettleImgsList: [],
      uploadsettleForm: {
        amount: '',
        memo: ''
      },
      uploadsettlerules: {
        amount: [
          { required: true, message: '请输入金额', trigger: 'blur' },
          { validator: validatePriceFn, trigger: 'blur' }
        ],
      }
    }
  },
  computed: {
    IMG_PREV() {
      return api.imgPrev;
    },
    adminId() {
      return utils.getAdminId()
    },
  },
  created() {
    this.uploadData.imageUserId = this.adminId
    this.getLiquidationDetail()
    // this.getDwLiquidateEstablishInfoByOid()
  },
  methods: {
    // 获取清算详情
    getLiquidationDetail() {
        this.isLoading = true;
        ajaxPost("/dwOrder/liquidateInfo", {
            liquidateOrderId: this.$route.query.orderId
        }).then(res => {
            console.log(res)
            this.isLoading = false;
            if (res.errorCode == 200) {
                this.lDetail = res.data[0];
                this.lDetail.productMainImageFile = this.lDetail.productMainImageFile ? this.IMG_PREV + this.lDetail.productMainImageFile : ''
                this.lDetail.supplier_rate = this.lDetail.itemFeeSplitting
                  ? accMul(this.lDetail.itemFeeSplitting.split(",")[1], 100)
                  : "";
                this.lDetail.dealer_rate = this.lDetail.itemFeeSplitting
                  ? accMul(this.lDetail.itemFeeSplitting.split(",")[0], 100)
                  : "";
                this.getBillList(3)
                this.getBillList(4)
            }
        }).catch(err => {
          this.isLoading = false;
          console.log(err)
        })
    },
    // 获取退货数量信息
    returnGoodInfo() {
        ajaxPost("/dwOrder/returnGoodInfo", {
            liquidateOrderId: this.$route.query.orderId,
        }).then(res => {
            console.log(res)
            if (res.errorCode == 200) {
                this.returnGoodsList = res.data
                this.currentReturnGoods = res.data[0]
            } else {
                
            }
        }).catch(err => {
            console.log(err)
        })
    },

    // 获取账单信息  1 - 销售商  2 - 平台  3 - 清算账单
    getBillList(billType) {
        ajaxPost("/dwOrder/getBillList", {
            billType: billType,
            orderPurchaseNumber: '',
            liquidateOrderId: this.lDetail.order_id
        }).then(res => {
            console.log(res);
            if (res.errorCode == 200) {
              if (billType == 3) {
                this.billList_final_list = res.data.map(element => {
                  let order_content = JSON.parse(element.liquidateDataInfo.order_content)
                  return {
                    ...element,
                    order_arrears_amount: (+element.order_arrears_amount).toFixed(2),
                    order_bill_amount: (+element.order_bill_amount).toFixed(2),
                    dealerSumPay: (element.order_arrears_amount + element.order_bill_amount).toFixed(2),
                    autoEstablish: order_content.autoEstablish,
                    sumOrderQuantity: order_content.sumOrderQuantity,
                    sumOrderEstablish: order_content.sumOrderEstablish,
                    orderRefundQuantity: order_content.orderRefundQuantity,
                    order_pay_amount: (+element.order_pay_amount).toFixed(2),
                    chargeBalance: element.chargeBalance 
                      ? (+element.chargeBalance > 0 ? +element.chargeBalance : 0).toFixed(2) 
                      : (element.order_arrears_amount + element.order_bill_amount).toFixed(2),
                    liquidateOrderPaymentList: element.liquidateOrderPaymentList ? element.liquidateOrderPaymentList.map(item => {
                      return {
                        ...item,
                        imageFiles: item.image_file ? item.image_file.split(',').map(ele => ele ? this.IMG_PREV + ele : '') : [],
                        restPay: (element.chargeBalance -item.order_payment_amount > 0 ? element.chargeBalance -item.order_payment_amount : 0).toFixed(2),
                      }
                    }) : []
                  }
                });
                this.billList_final = this.billList_final_list[0] || {}
              }

              if (billType == 4) {
                this.platform_billList_final_list = res.data.map(element => {
                  // let order_content = JSON.parse(element.liquidateDataInfo.order_content)
                  return {
                    ...element,
                    order_arrears_amount: (+element.order_arrears_amount).toFixed(2),
                    order_bill_amount: (+element.order_bill_amount).toFixed(2),
                    dealerSumPay: (element.order_arrears_amount + element.order_bill_amount).toFixed(2),
                    // autoEstablish: order_content.autoEstablish,
                    // sumOrderQuantity: order_content.sumOrderQuantity,
                    // sumOrderEstablish: order_content.sumOrderEstablish,
                    // orderRefundQuantity: order_content.orderRefundQuantity,
                    order_pay_amount: (+element.order_pay_amount).toFixed(2),
                    sum_pay_amonut: (element.order_arrears_amount + element.order_bill_amount).toFixed(2),
                    chargeBalance: element.chargeBalance 
                      ? (+element.chargeBalance > 0 ? +element.chargeBalance : 0).toFixed(2) 
                      : (element.order_arrears_amount + element.order_bill_amount).toFixed(2),
                    liquidateOrderPaymentList: element.liquidateOrderPaymentList ? element.liquidateOrderPaymentList.map(item => {
                      return {
                        ...item,
                        imageFiles: item.image_file ? item.image_file.split(',').map(ele => ele ? this.IMG_PREV + ele : '') : [],
                        restPay: (element.chargeBalance -item.order_payment_amount > 0 ? element.chargeBalance -item.order_payment_amount : 0).toFixed(2),
                      }
                    }) : []
                  }
                });
                this.platform_billList_final = this.platform_billList_final_list[0] || {}
              }
                
                
            } else {
                
            }
        }).catch(err => {
            console.log(err)
        })
    },
    // 获取当前账单
    getBillPayDetail(item, pay_ele) {
        this.billPeriodPayDetail = item
        this.billSinglePayDetail = pay_ele
        this.supplierSurePayPop = true
    },
    // 确认销售商付款
    platformSurePay(state) {
        ajaxPost("/dwOrder/confirmOrderPaymentByliquidate", {
            "liquidatePaymentNumber": this.billSinglePayDetail.order_number,
            "dwLiquidatePaymentState": state,
            "liquidatePaymentNumberByBill": this.billPeriodPayDetail.order_number,
            "liquidateOrderId": this.lDetail.order_id,
            "billId": this.billPeriodPayDetail.order_id,
        }).then(res => {
            console.log(res);
            if (res.errorCode == 200) {
                this.supplierSurePayPop = false
                this.$message.success('操作成功')
                this.getBillList(3)
                this.getBillList(4)
            } else {
                this.$message.error(res.errorMsg || '操作失败') 
            }
        }).catch(err => {
            console.log(err)
        })
    },

    // 平台上传结算凭证
    openUploadSettle() {
      this.platformPopShowData = {
        sumAmount: this.platform_billList_final.sum_pay_amonut,
        hadPaidAmount: this.platform_billList_final.order_pay_amount,
        restPayAmount: (this.platform_billList_final.sum_pay_amonut - this.platform_billList_final.order_pay_amount),
      }

      this.uploadsettleImgsList = [];
      this.uploadsettleForm.amount = '';
      this.uploadsettleForm.memo = '';

      this.uploadsettlePayPop = true
    },
    inputPriceHandle(e) {
      const reg = /((^\s{0}|^\d*))(\.\d*){0,1}$/
      if (reg.test(e)) {
        this.uploadsettleForm.amount = e
      }
    },
    blurPriceHandle() {
      if (this.uploadsettleForm.amount != '') {
        let val = parseFloat(this.uploadsettleForm.amount);
        this.uploadsettleForm.amount = val.toFixed(2);
      }
    },
    // 上传图片
    beforeUpload(file) {
      console.log('beforeUpload', file)
      if (!(file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png')) {
        this.$message({
          type: 'warning',
          message: '必须为图片且要求是.png或.jpg格式!'
        })
        return false
      } else if (file.size > 10 * 1024 * 1024) {
        this.$message({
          type: 'warning',
          message: '图片大小不能超过10M!'
        })
        return false
      }
    },
    onSuccess(response, file, fileList) {
      console.log('onSuccess', response, file, fileList)
      this.uploadsettleImgsList = fileList
    },
    onError(err, file, fileList) {
      console.log('onError', err, file, fileList)
      this.$message({
        type: 'error',
        message: '图片上传失败!'
      })
    },
    // 图片删除
    handleRemove(file, fileList) {
      console.log(file, fileList)
      this.uploadsettleImgsList = fileList
    },
    uploadsettleSubmit() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          console.log('this.uploadsettleForm', this.uploadsettleForm)
          console.log('this.uploadsettleImgsList', this.uploadsettleImgsList)
          let ImgsList = this.uploadsettleImgsList.map(item => {
            return {
              imageFiles: item.response.data.imageFiles,
              imgId: item.response.data.imgId
            }
          })
          let ImgsListStr = JSON.stringify(ImgsList)
          ajaxPost("/dwOrder/saveLiquidatePayment", {

            "supplierUserId": this.lDetail.supplier_user_id,
            "dealerUserId": this.lDetail.dealer_user_id,
            "liquidateOrderId": this.lDetail.order_id,
            "itemId": this.lDetail.item_id,
            "imgJson": ImgsListStr,
            "liquidateBillOrderId": this.platform_billList_final.order_id,
            "orderLiquidateAmount": this.uploadsettleForm.amount,
            "orderLiquidateMemo": this.uploadsettleForm.memo,
            "adminId": this.adminId
          }).then(res => {
            console.log(res)
            if (res.errorCode == 200) {
              this.uploadsettlePayPop = false
              this.$message.success(res.errorMsg || '操作成功')
              this.getBillList(3)
              this.getBillList(4)
            } else {
              this.$message.error(res.errorMsg || '操作失败')
            }
          }).catch(err => {
            console.log(err)
          })
        }
      })
    },
    
  }
};
</script>

<style scoped lang="scss">
.page-section {
  padding: 24px 24px;
  background: #fff;
  margin-bottom: 16px;
}
.header-handle-box {
    min-width: 980px;
    box-sizing: border-box;
    margin-top: 24px;
    border: 1px solid #e6e6e6;
    background: #fafafa;
    padding: 40px 80px;
    .state {
        font-size: 20px;
        color: #333;
        font-weight: 500;
        &.red {color: #F81D22;}
    }
    .status {
      color: #F81D22;
      margin-left: 10px;
      font-size: 16px;
    }
    .btns {
        margin-top: 40px;
        .cg-btn {margin-right: 20px;}
    }
    .tip {
        margin-top: 14px;
        height:20px;
        font-size:14px;
        color:rgba(51,51,51,0.6);
        line-height:20px;
    }
    .tip-small {
        margin-left: 8px;
        height:20px;
        font-size:14px;
        color:rgba(51,51,51,0.6);
        font-size: normal;
        line-height:20px;
    }
}
.basic-info {
    &.mgt-24 {
        margin-top: 24px;
    }
    &.mgt-40 {
        margin-top: 40px;
    }
    .line {
      padding-bottom: 16px;
      font-size:14px;
      line-height:22px;
      .lab {
        color:rgba(0,0,0,0.85);
      }
      .val {
        color:rgba(0,0,0,0.65);
      }
      &.blue .lab , &.blue .val { color: #1890FF}
      .green { color: #52C41A;}
      .text-btn {
          margin-left: 16px;
          background: transparent;
          border: none;
          font-size: 14px;
          color: #1890FF;
          outline: none;
          cursor: pointer;
          &:hover {
              text-decoration: underline;
          }
      }
    }
}
.basic-wrap {
  margin-top: 24px;
  padding: 24px;
  border: 1px solid rgba(0,0,0,0.06);
  .img-wrap {
    float: left;
    width: 100px; height: 100px;
    border: 1px solid #f0f0f0;
    .img {
      width: 100px; height: 100px;
    }
  }
  .basic-info {
    padding-left: 136px;
    .line {
      padding-bottom: 16px;
      font-size:14px;
      line-height:22px;
      .lab {
        color:rgba(0,0,0,0.85);
      }
      .val {
        color:rgba(0,0,0,0.65);
        &.tit {
           display: inline-block;
           vertical-align: top;
           width: 720px;
        }
      }
    }
  }
}

.take-order-table {
  &.scroll {
      height: 50vh;
      overflow-y: auto;
      overflow-x: visible;
  }
  .table {
    border: 1px solid #E6E6E6;
    width: 100%;
    min-width: 980px;
    border-spacing: 0;
    border-collapse: collapse;
    font-size:14px;
    tr {
      height: 50px;
    }
    tr.th {
      background: #fafafa;
    }
    tr th {
      color:rgba(0,0,0,0.85);
      font-weight: normal;
    }
    td {
      border: 1px solid #E6E6E6;
      text-align: center;
      color:rgba(0,0,0,0.85);
    }
    &.min-400 {
        min-width: 400px;
    }
  }
  &.mgt-24 {
      margin-top: 24px;
  }
  &.clearing {
      margin-top: 24px;
  }
  &.clearing tr th {
    border: 1px solid #E6E6E6;
  }
  &.clearing tr th:last-child, &.clearing tr td:last-child{
    color: #F81D22;
  }
  
}

.gap-line {
    margin: 40px 0;
    height: 1px;
    background: #E6E6E6;
}

.time-line-title {
  margin-top: 16px;
  .time-line-title-h4 {
    font-size: 14px;
    font-weight: 500;
  }
  .time-line-title-sub {
    font-size: 13px;
  }
}



.time-line {
    margin-top: 24px;
    list-style: none;
    .item {
        position: relative;
        .item-tail {
            position: absolute; top: 10px; left: 4px;
            width: 2px; height: 100%;
            background: #F7F7F7;
        }
        .item-node {
            position: absolute; top: 10px; left: 0;
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background: #D9D9D9;
        }
        &:first-child .item-node {
            background: #2A2E3F
        }
        &:last-child .item-tail {
            width: 0;
        }
        .item-content {
            padding-left: 32px;
            font-size:14px;
            font-weight:500;
            color:rgba(0,0,0,0.85);
            line-height:24px;
            padding-bottom: 16px;
        }
        .item-tit {
            padding-bottom: 8px;
        }
        .item-box {
            background:rgba(0,0,0,0.02);
            border-radius:2px;
            padding: 24px;
            .pdb-12 {
                padding-bottom: 12px;
            }
            .pdb-6 {
                padding-bottom: 6px;
            }
            .grey {
                color:rgba(0,0,0,0.45);
            }
            .green {
                color: #52C41A
            }
            .blue {
                color: #1890FF
            }
        }
        .title {
          display: inline-block;
          width: 450px;
        }
        .time {font-size: 13px; color: #000; margin-right: 6px;}
        .img {
          width: 100px; height: 100px; border: 1px solid #eee;
          vertical-align: top;
        }
    }
    .sub-time-line {
        list-style: none;
        .sub-item {
            position: relative;
            padding-left: 24px;
            &::before {
                content: ' ';
                position: absolute; top: 15px; left: 3px;
                width: 1px; height: calc(100% - 12px);
                background: #D8D8D8;
            }
            &::after {
                content: ' ';
                position: absolute; top: 6px; left: 0;
                width: 7px;
                height: 7px;
                border-radius: 50%;
                background: #fff;
                border: 1px solid #D8D8D8;
                box-sizing: border-box;
            }
            &:first-child::after {
                background: #FF9C6E;
                border: 1px solid #FF9C6E;
            }
            &:last-child::before {
                width: 0;
            }
        }
    }

}

.address-wrap {
    padding-top: 16px;
}
.address-label {
    font-size: 14px;
    font-weight: 500;
    color: #666;
    line-height: 30px;
}
.address-content {
    padding: 6px 0px ;
    color: #333;
    font-size: 13px;
    .line {
        margin-bottom: 6px;
        &:last-child {margin-bottom: 0;}
    }
    .gap {
        margin-left: 30px;
    }
}
.cg-dialog-body {
  padding: 24px;
  .line {
    font-size: 14px; line-height: 2; color: #555;
    .black {color: #111;}
    .red { color: #F81D22;}
    &.pdb-20 {padding-bottom: 20px;}
  }
}
</style>
 


// WEBPACK FOOTER //
// src/pages/order/liquidation.vue